import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const BaseLayoutStyle = makeStyles()((theme: Theme) => ({
  root: {
    '& .no-wrap': {
      whiteSpace: 'nowrap',
    },
    '& a': {
      color: theme.palette.primary.main,
    },
    '& a.MuiButtonBase-root ': {
      color: theme.palette.primary.contrastText,
    },
  },
  boxMargin: {
    marginLeft: '230px',
    marginTop: '140px',
    [theme.breakpoints.between(600, 1279)]: {
      marginLeft: '39px',
      marginTop: '96px',
    },
    [theme.breakpoints.between(0, 600)]: {
      marginLeft: '15px',
      marginTop: '46px',
      marginRight: '15px',
    },
  },
}))

export default BaseLayoutStyle
